<ng-container *ngIf="items$ | async as items">
  <ng-container *ngIf="items.length">
    <ng-container *ngIf="isMobile$ | async; else carouselTemplate">
      <div class="banner-carousel-peek">
        <ng-container *ngFor="let item of items">
          <div class="banner-carousel-peek-slide" [style.width]="widthOneSlideOnMobile$ | async">
            <ng-container
              [cxComponentWrapper]="{
                flexType: item.typeCode,
                typeCode: item.typeCode,
                uid: item?.uid,
              }"
            ></ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #carouselTemplate>
      <sd-swiper [items]="items" [config]="config$ | async">
        <ng-template #slide let-item="item" let-classList="classList">
          <ng-container
            [cxComponentWrapper]="{
              flexType: item.typeCode,
              typeCode: item.typeCode,
              uid: item?.uid,
            }"
          ></ng-container>
        </ng-template>
      </sd-swiper>
    </ng-template>
  </ng-container>
</ng-container>
